import { render, staticRenderFns } from "./PrismsUserSwitchToEmailMfaDialog.vue?vue&type=template&id=49eafb6c&"
import script from "./PrismsUserSwitchToEmailMfaDialog.vue?vue&type=script&lang=js&"
export * from "./PrismsUserSwitchToEmailMfaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports